import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import EmergencyBanner from "@/components/EmergencyBanner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import RequestCare from "@/pages/RequestCare";
import Careers from "@/pages/Careers";
import Consultation from "@/pages/Consultation";
import ServiceAreas from "@/pages/ServiceAreas";
import ReferralPartners from "@/pages/ReferralPartners";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

const PublicShell = ({ children }) => (
  <>
    <EmergencyBanner />
    <Navbar />
    <main className="min-h-[60vh]">{children}</main>
    <Footer />
  </>
);

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <RouteTracker />
        <Routes>
          <Route path="/" element={<PublicShell><Home /></PublicShell>} />
          <Route path="/about" element={<PublicShell><About /></PublicShell>} />
          <Route path="/services" element={<PublicShell><Services /></PublicShell>} />
          <Route path="/request-care" element={<PublicShell><RequestCare /></PublicShell>} />
          <Route path="/careers" element={<PublicShell><Careers /></PublicShell>} />
          <Route path="/consultation" element={<PublicShell><Consultation /></PublicShell>} />
          <Route path="/service-areas" element={<PublicShell><ServiceAreas /></PublicShell>} />
          <Route path="/referral-partners" element={<PublicShell><ReferralPartners /></PublicShell>} />
          <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
          <Route path="/terms" element={<PublicShell><Terms /></PublicShell>} />
          <Route path="/privacy" element={<PublicShell><Privacy /></PublicShell>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
